/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'
import NavSelectOption from './NavSelectOption'
import contains from 'utils/contains'
import styled from '@emotion/styled'
import { css } from 'emotion'

const duration = 200

const StyledUl = styled('ul')`
  min-width: 200px;
  background: white;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);
  list-style: none;
  margin: 0;
  padding: 8px;
  position: absolute;
  top: 100%;
  right: 0;
  transition: opacity ${duration}ms ease-in-out,
    transform ${duration}ms ease-in-out;
  z-index: 1;
`

const slide = {
  entering: css`
    opacity: 0;
    transform: translateY(8px);
  `,
  entered: css`
    opacity: 1;
    transform: translateY(0);
  `,
  exiting: css`
    opacity: 0;
    transform: translateY(8px);
  `,
}

class NavSelectMenu extends Component {
  constructor(props) {
    super(props)
    this.state = { active: {} }
    this.menuRef = React.createRef()
  }

  componentDidMount() {
    this.props.show && this.handleShow()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.handleShow()
    } else if (prevProps.show && !this.props.show) {
      this.handleHide()
    }
  }

  componentWillUnmount() {
    this.handleHide()
  }

  handleShow() {
    document.addEventListener('click', this.onClickOutside)
    this.focusOnMount()
  }

  handleHide() {
    document.removeEventListener('click', this.onClickOutside)
  }

  updateActiveDescendant = e => {
    this.setState({
      active: {
        id: e.target.getAttribute('data-id'),
        index: +e.target.getAttribute('data-index'),
      },
    })
  }

  focusOnMount = () => {
    setTimeout(() => {
      if (!this.menuRef.current) return
      this.menuRef.current.querySelector('a').focus()
    }, 300)
  }

  focusOptionByIndex = index => {
    if (this.menuRef.current) {
      this.menuRef.current.querySelectorAll('a')[index].focus()
    }
  }

  onClickOutside = e => {
    if (
      this.props.show &&
      this.menuRef.current &&
      !contains(this.menuRef.current, e.target)
    ) {
      this.props.onClose()
    }
  }

  handleKeyDown = e => {
    const { options } = this.props
    const { active } = this.state

    switch (e.keyCode) {
      // esc
      case 27:
        this.props.onClose()
        break
      // end key
      case 35:
        this.focusOptionByIndex(options.length - 1)
        break
      // home key
      case 36:
        this.focusOptionByIndex(0)
        break
      // up arrow
      case 38:
        this.focusOptionByIndex(
          active.index < 1 ? options.length - 1 : active.index - 1
        )
        break
      // down arrow
      case 40:
        this.focusOptionByIndex(
          active.index == options.length - 1 ? 0 : active.index + 1
        )
        break
      default:
        break
    }
  }

  render() {
    const { id, onClose, options, show } = this.props
    return (
      <Transition in={show} mountOnEnter unmountOnExit timeout={duration}>
        {status => (
          <StyledUl
            className={`${slide[status]}`}
            aria-activedescendant={this.state.active.id}
            aria-labelledby={id}
            role='listbox'
            ref={this.menuRef}
            tabIndex='-1'
            onKeyDown={this.handleKeyDown}
          >
            {options.map((opt, i) => (
              <NavSelectOption
                id={`${id}-${i}`}
                key={opt.to}
                index={i}
                to={opt.to}
                onClick={onClose}
                onFocus={this.updateActiveDescendant}
              >
                {opt.name}
              </NavSelectOption>
            ))}
          </StyledUl>
        )}
      </Transition>
    )
  }
}

NavSelectMenu.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
      to: PropTypes.string.isRequired,
    })
  ).isRequired,
  show: PropTypes.bool,
}

export default NavSelectMenu
